module.exports = __webpack_public_path__ + "static/media/lg59.daefa41b.png";